/**
 * Error raised when execution failed.
 */
export class FailedZExecutionError extends Error {
    /**
     * Constructs aborted execution error.
     *
     * @param failure - Execution failure.
     * @param message - Error message.
     */
    constructor(failure, message = 'Execution failed') {
        super(failure !== undefined ? `${message}. ${failure}` : message);
        this.failure = failure;
        this.name = 'Failed';
    }
}
//# sourceMappingURL=failed-execution-error.js.map